import axios from '@/plugins/axios'
import alert from '@/plugins/alert'
import router from '@/router'

const COURSE_API = '/courses/'

export default {
  namespaced: true,
  state: {
    courses: [],
    course: null
  },
  actions: {
    fetchCourses ({ commit }, options) {
      return axios.get(COURSE_API, { ...options })
        .then(courses => commit('setCourses', courses))
        .catch(e => alert.error(e))
    },
    fetchCoursesByTitle ({ dispatch }, keyword) {
      if (!keyword) return
      return dispatch('fetchCourses', { params: { 'title_contains': keyword }, hideLoading: true })
    },
    fetchCourse ({ commit }, courseId) {
      commit('setCourse', null)
      return axios.get(COURSE_API + courseId)
        .then(course => commit('setCourse', course))
        .catch(e => alert.error(e))
    },
    createCourse ({ commit }, course) {
      return axios.post(COURSE_API, course)
        .then(course => {
          commit('setCourse', course)
          router.push(`/course/${course.id}`)
          alert.success('Create course successfully!')
        })
        .catch(e => alert.error(e))
    },
    updateCourse ({ commit, state }, { id, ...course }) {
      return axios.put(COURSE_API + id, course)
        .then(course => {
          commit('setCourse', course)
          alert.success('Update course successfully!')
        })
        .catch(e => alert.error(e))
    },
    removeCourse ({ commit }, courseId) {
      return axios.delete(COURSE_API + courseId)
        .then(course => {
          commit('removeCourse', course.id)
        })
        .catch(e => alert.error(e))
    },
    async removeCourses ({ dispatch }, items) {
      for (let item of items) {
        await dispatch('removeCourse', item.id)
      }
    }
  },
  mutations: {
    setCourses (state, courses) {
      state.courses = courses
    },
    setCourse (state, course) {
      state.course = course
    },
    removeCourse (state, courseId) {
      const i = state.courses.findIndex(({ id }) => id === courseId)
      if (i > -1) {
        state.courses.splice(i, 1)
      }
    }
  },
  getters: {
    courses: (state) => {
      return state.courses
    },
    course: (state) => {
      return state.course
    }
  }
}
